/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

import * as Linking from 'expo-linking';

export default {
  prefixes: [Linking.makeUrl('/')],
  initialRouteName: 'Sign_In',
  config: {
    screens: {
      Sign_In: 'login-screen',
      login: '/login',
      RegisterScreen: '/RegisterScreen',
      Sign_Up: 'register-screen',
      Password_Reset: 'forgot-password-screen',
      Change_Password: 'reset-password-screen',
      Home: 'home',
      Properties: 'properties',
      PropertyAddress: 'propertyAddress',
      PropertySection: 'propertySection',
      PropertyDetails: 'PropertyDetails',
      LandlordDetails: 'LandlordDetails',
      Certification: 'Certification',
      Requirements: 'Requirements',
      Licensing: 'Licensing',
      Utilities: 'Utilities',
      financeDetails: 'financeDetails',
      Tenants: '/tenants',
      News: 'News',
      Setting: 'Setting',
      ChangePassword: 'ChangePassword',
      TenantArchive: 'TenantArchive',
      PropertyArchive: 'PropertyArchive',
      MyAccount: 'MyAccount',
      ContactUs: 'contact-us',
      AboutUs: 'about-us',
      TenantDeposit: 'TenantDeposit',
      TenantReminder: 'TenantReminder',
      PaymentIncomingDetails: 'payments/incoming/new',
      PaymentOutgoingDetails: 'payments/outgoing/new',
      PaymentNewProperty: 'payments/incoming/new/:property_id',
      EditReminder: 'Reminder/Edit/:id',
      AddReminder: 'Reminder/New',
      Reminder: 'Reminder',
      AccountEdit: 'Account/Edit',
      PropertyDetailsMore: 'PropertyDetails/:id',
      PropertyInfo: 'PropertyInfo/:id',
      TeanantInfo: '/TeanantInfo/:id',
      financeDetails: "/financeDetails/:id",
      TenantDetails: '/tenants/TenantDetails',
      PropertyTenantDetails: '/property/TenantDetails/:id',
      PropertiesInfoDetails:'/PropertiesInfoDetails/:id',
      PropertyDocumentation: '/tenants/PropertyDocumentation/:id',
      RentalOffers: '/tenants/RentalOffers/:id',
      TeanantOnboarding: '/tenants/TeanantOnboarding/:id',
      TeanantOffboarding: '/tenants/TeanantOffboarding/:id',
      HoldingDeposit: '/tenants/HoldingDeposit/:id',
      IdAndReference: '/tenants/IdAndReference/:id',
      RegisterDeposit: '/tenants/registerDeposit/:id',
      Certification:"/Certification/:id",
      TenancyAgreement: '/tenants/TenancyAgreement/:id',
      MoveIn: '/tenants/MoveIn/:id',
      DepositProtectHomeSetup: '/tenants/DepositProtectHomeSetup/:id',
      Maintenance: '/maintenanceissue/:id',
      RentCollectionSignUp: '/tenants/RentCollectionSignUp/:id',
      MediaHub: 'media-hub',
      'MediaHub Details': 'media-hub/:data',
      MediaVideoDetails:'/MediaVideoDetails',
      DocumentArchive: 'DocumentArchive',
      MyDocs: 'MyDocs',
      LegalBits:'/legal-bits',
      Charity:'/charity',
      hello:'hello',
      HubitaEmbedX: 'hubita/iframe',
      CommonBuyCertificate:"/certificate/buy",
      Notice:'tenants/TeanantOffboarding/Notice',
      financeInsuranceQuote:'/financeInsuranceQuote',
      addproperty:'/tenants/addproperty',
      CurrentOnboards: "/tenants/CurrentOnboards",
      CompletedOnboards:"/tenants/CompletedOnboards",
      ArchivedOnboards:"/tenants/ArchivedOnboards",
      RenewalsFixedTerm:"/tenants/RenewalsFixedTerm",
      MyInvoices:"/MyInvoices",
      BankAccount:"/BankAccount",
      Payments:"/Payments",
      HubFlow:"/HubFlow",
      MaintenanceProject:"/maintenance-project",
      NewIssues:"/NewIssuePage",
      New_issues:'/maintenance/new-issues/:id',
      ActiveProject:"/maintenance/active-jobs",
      CompletedProject:"/maintenance/:id",
      ActiveProjects:'/maintenance/active-jobs/:id',
      CompletedProjects:'/maintenance/:type/:id',
      ArchivedProject:"/maintenances/:id",
      ArchivedProjects:'/maintenances/:type/:id',
    },

  },
};
